import { useLocation } from 'react-router-dom';
import { SeoHelmet } from './SeoHelmet';
import { canonicalizeUrl, SITE_URL } from '@/shared/seo/seoRouting';
import { getBaseAndPrefix } from '@/i18n/routingUtils';

const HREFLANG_CONFIGS = [
  { prefix: '', hrefLang: 'x-default' },
  { prefix: '', hrefLang: 'en' },
  { prefix: '/en-US', hrefLang: 'en-US' },
  { prefix: '/in-IT', hrefLang: 'it' },
  { prefix: '/nl-NL', hrefLang: 'nl' },
  { prefix: '/es-ES', hrefLang: 'es' },
  { prefix: '/tr-TR', hrefLang: 'tr' },
  { prefix: '/fr-FR', hrefLang: 'fr' },
  { prefix: '/de-DE', hrefLang: 'de' },
  { prefix: '/pt-PT', hrefLang: 'pt' },
];

function shouldNoIndex(pathname: string) {
  return (
    pathname.startsWith('/supplier/dashboard') ||
    pathname.startsWith('/admin') ||
    pathname.startsWith('/partner') ||
    pathname.startsWith('/auth/') ||
    pathname.startsWith('/guest/') ||
    pathname === '/supplier/login' ||
    pathname === '/supplier/register' ||
    pathname === '/supplier/forgot-password' ||
    pathname.startsWith('/supplier/login/') ||
    pathname.startsWith('/supplier/register/') ||
    pathname.startsWith('/supplier/forgot-password/') ||
    pathname === '/change-password' ||
    pathname === '/accept-invite' ||
    pathname === '/login' ||
    pathname === '/register' ||
    pathname === '/pay' ||
    pathname.startsWith('/booking-confirmed/') ||
    pathname.startsWith('/review/')
  );
}

export function RouteSeo() {
  const location = useLocation();
  const { base } = getBaseAndPrefix(location.pathname);
  // Canonical URL: always use the non-prefixed version (base path)
  // This prevents "duplicate without user-selected canonical" issues
  // where locale-prefixed pages were being treated as separate pages.
  // The hreflang tags handle language/region alternates.
  const canonicalUrl = canonicalizeUrl(base);
  // Generate dynamic hreflang alternate links for all supported languages
  const hreflang = HREFLANG_CONFIGS.map((cfg) => {
    const localizedPath = cfg.prefix ? `${cfg.prefix}${base === '/' ? '' : base}` : base;
    return {
      hrefLang: cfg.hrefLang,
      href: `${SITE_URL}${localizedPath}`,
    };
  });

  return <SeoHelmet canonical={canonicalUrl} noindex={shouldNoIndex(base)} hreflang={hreflang} />;
}
